import { ProductOrder } from './product-order';
import { Customer } from './customer';

export class Checkout {
  subtotal: number;
  prettySubtotal: string;

  delivery_fee: number;
  prettyDeliveryFee: string;

  total: number;
  prettyTotal: string;

	items: ProductOrder[];

	customer: Customer;
  editingCustomer = false;
  confirmedCustomerData = false;

  mode: 'delivery'|'pickup';
  selectedDistrictObj: {bairro: string, valor: string};

  paymentType: 'credit'|'debit'|'cash'|'pix'|'transfer';
  changeNeeded: number;
}